import { render, staticRenderFns } from "./VariantDivider.vue?vue&type=template&id=c329308c&scoped=true&lang=html&"
import script from "./VariantDivider.vue?vue&type=script&lang=js&"
export * from "./VariantDivider.vue?vue&type=script&lang=js&"
import style0 from "./VariantDivider.vue?vue&type=style&index=0&id=c329308c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c329308c",
  null
  
)

export default component.exports